import _ from "lodash";

/** Badge colors for product intake table status pills. */
export const PRODUCT_INTAKE_STATUS_COLORS = {
  pending: { background: "#9C9C9C" },
  on_hold: { background: "#126ABC" },
  shopping_in_progress: { background: "#7B61FF" },
  shopping_completed: { background: "#00C046" },
  approved: { background: "#00C046" },
  rejected: { background: "#FF3850" },
  review: { background: "#9C9C9C" },
  recieved: { background: "#126ABC" },
  wait_to_deliver: { background: "#FF8500" },
  un_delivered: { background: "#FF8500" },
  delivered: { background: "#126ABC" },
  awaiting_approval: { background: "#E17B0B" },
  item_delivered: { background: "#00C046" },
  received_at_the_warehouse: { background: "#126ABC" },
};

/** Status filter dropdown (admin + personal shopper product intake). */
export const PRODUCT_INTAKE_STATUS_FILTER_OPTIONS = [
  { value: "all", label: "All Status" },
  { value: "pending", label: "Pending" },
  { value: "on_hold", label: "On Hold" },
  { value: "shopping_in_progress", label: "In Progress" },
  { value: "shopping_completed", label: "Shopping Completed" },
  { value: "approved", label: "Approved" },
  { value: "rejected", label: "Rejected" },
  { value: "awaiting_approval", label: "Awaiting Approval" },
  { value: "item_delivered", label: "Item Delivered" },
  { value: "received_at_the_warehouse", label: "Received at the warehouse" },
];

/**
 * Shared intake workflow actions — Super Admin + Personal Shopper (non–online-shopping items).
 */
export const PRODUCT_INTAKE_STATUS_ACTIONS = [
  { status: "approved", label: "Approve", hideWhenCurrent: true },
  { status: "pending", label: "Pending" },
  { status: "on_hold", label: "On Hold" },
  { status: "shopping_in_progress", label: "In Progress" },
  { status: "shopping_completed", label: "Shopping Completed" },
  { status: "received_at_the_warehouse", label: "Received at the warehouse" },
  { status: "rejected", label: "Rejected" },
];

export function normalizeProductIntakeStatus(status) {
  const key = String(status || "").toLowerCase();
  if (!key || key === "created") return "pending";
  return key;
}

export function formatProductIntakeStatusLabel(status) {
  const key = normalizeProductIntakeStatus(status);
  const fromAction = PRODUCT_INTAKE_STATUS_ACTIONS.find((a) => a.status === key);
  if (fromAction) return fromAction.label;
  const fromFilter = PRODUCT_INTAKE_STATUS_FILTER_OPTIONS.find((o) => o.value === key);
  if (fromFilter) return fromFilter.label;
  return key ? _.startCase(key.replace(/_/g, " ")) : "Pending";
}

export function getProductIntakeStatusColor(status) {
  const key = normalizeProductIntakeStatus(status);
  return PRODUCT_INTAKE_STATUS_COLORS[key]?.background ?? "#9C9C9C";
}

export function isOnlineShoppingIntakeType(orderType) {
  const normalized = String(orderType || "").toLowerCase().replace(/\s+/g, "_");
  return normalized === "online_shopping";
}

/** After approval or rejection, intake item edits are locked. */
export function isProductIntakeLocked(status) {
  const key = normalizeProductIntakeStatus(status);
  return key === "approved" || key === "rejected" || key === "shopping_completed" || key === "item_delivered";
}
